import {BaseApiService} from "../../../StarterKit/Service/BaseApiService";

export default class ApiExport extends BaseApiService {
    async getDataToExport(query) {
        this.setGetMethod();
        this.setSecureByService();
        this.setApiRoute(sessionStorage['language'] + `/export?${query}`);
        return await this.callApi();
    }
}